const HiltonSilver = props => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_301_84)">
      <g>
        <path
          d="M14 2.3422C15.2376 1.62767 16.7624 1.62767 18 2.3422L26.6656 7.3453C27.9032 8.05983 28.6656 9.38034 28.6656 10.8094V20.8156C28.6656 22.2447 27.9032 23.5652 26.6656 24.2797L18 29.2828C16.7624 29.9973 15.2376 29.9973 14 29.2828L5.33438 24.2797C4.09677 23.5652 3.33438 22.2447 3.33438 20.8156V10.8094C3.33438 9.38034 4.09677 8.05983 5.33438 7.3453L14 2.3422Z"
          fill="#828282"
        />
        <path
          d="M14 2.3422C15.2376 1.62767 16.7624 1.62767 18 2.3422L26.6656 7.3453C27.9032 8.05983 28.6656 9.38034 28.6656 10.8094V20.8156C28.6656 22.2447 27.9032 23.5652 26.6656 24.2797L18 29.2828C16.7624 29.9973 15.2376 29.9973 14 29.2828L5.33438 24.2797C4.09677 23.5652 3.33438 22.2447 3.33438 20.8156V10.8094C3.33438 9.38034 4.09677 8.05983 5.33438 7.3453L14 2.3422Z"
          fill="white"
          fillOpacity={0.08}
        />
      </g>
      <g filter="url(#filter0_d_301_84)">
        <path
          d="M11.1017 21.1L12.7927 18.991C13.6857 19.922 14.8827 20.587 16.0892 20.587C17.1057 20.587 17.9037 20.036 17.9037 19.2285C17.9037 18.478 17.4192 17.8415 15.4147 17.414C12.8972 16.8725 11.3867 15.495 11.3867 13.4525C11.3867 11.163 13.2677 9.472 15.9087 9.472C17.6757 9.472 19.2527 10.118 20.3927 11.163L18.7967 13.348C17.9512 12.6165 17.0202 12.075 16.0417 12.075C15.2057 12.075 14.5597 12.55 14.5597 13.2055C14.5597 13.9465 15.0917 14.4975 16.8397 14.8965C19.6802 15.552 21.0767 16.9485 21.0767 19.0765C21.0767 21.461 19.1577 23.228 16.0987 23.228C14.0847 23.228 12.2987 22.43 11.1017 21.1Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        x={9.10181}
        y={9.472}
        width={13.9749}
        height={17.756}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_301_84"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_301_84"
          result="shape"
        />
      </filter>
      <clipPath>
        <rect width={32} height={32} fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default HiltonSilver
